import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Breadcrumbs from "../../common/Breadcrumbs/Breadcrumbs";
import { useLocation } from "react-router-dom";
import {
    getOptedCampaignsListByBrand
} from "../../../store/campaignStore/actions/CreateCampaignActions/getOptedCampaignsListByBrandAction";
import DataTable from "react-data-table-component";
import moment from "moment/moment";
import { useSelector, useDispatch } from "react-redux";
import { downloadReferenceVideo } from "../../../store/campaignStore/actions/CreateCampaignActions/downloadReferenceVideoActions";
import { FiDownload } from "react-icons/fi";
import { useToast } from "../../../hooks/useToast";

const BrandCampaignsDetails = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch()
    const Toast = useToast();
    const getUserInfoReducerData = useSelector(state => state.getUserInfoReducer.data);

    const [formValues, setFormValues] = useState({
        campaignId: "",
        name: "",
        purpose: "",
        platform: "",
        campaignType: "",
        startDate: "",
        endDate: "",
        script: "",
        dialogue: "",
        backgroundColor: "",
        otherProperties: "",
        mediaFileLink: "",
        isLocationRequired: false,
        uploadDuration: "",
        referenceVideoUpload: "",
    });

    const [refVideoFileName, setRefVideoFileName] = useState("");
    const [isRefVideoUploading, setIsRefVideoUploading] = useState(false);
    const [isDownloadingReferenceVideo, setIsDownloadingReferenceVideo] = useState(false);

    useEffect(() => {
        if (location.state?.campaign) {
            setFormValues(location.state.campaign);

            dispatch(getOptedCampaignsListByBrand({ 'campaignId': location.state?.campaign.campaignId }, (status, response, message) => {
                console.log("for Campaign detail status, response, message", status, response, message)
                if (status === 200) {
                    setFormValues((prev) => ({
                        ...prev,
                        channelNameViewArray: response,
                    }));
                }
            }));
        }
    }, [location.state]);


    const columns = [
        {
            name: 'Channel Name',
            selector: row => row.channelName,
            sortable: true,
            style: {
                width: '10rem',  // Set a smaller width for this column
            },
            wrap: true,
        },
        {
            name: 'Influencer Name',
            selector: row => row.influencerName,
            sortable: true,
            style: {
                width: '10rem',  // Adjust the width as needed
            },
            wrap: true,
        },
        {
            name: 'Views',
            selector: row => row.views,
            sortable: true,
            style: {
                width: '10rem',  // Adjust the width as needed
            },
        },
        {
            name: 'Upload Date',
            selector: row => row.publishedDateTime ? moment.utc(row.publishedDateTime.split("+")[0]).local().format("DD-MM-YYYY hh:mm A") : "--",
            sortable: true,
            style: {
                width: '12rem',  // Adjust the width as needed
            },
            wrap: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            style: {
                width: '10rem',  // Adjust the width as needed
            },
        },
        {
            name: 'Video URL',
            cell: row => (
                <a
                    href={row.contentURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 underline hover:text-blue-700"
                >
                    {row.contentURL}
                </a>
            ),
            sortable: true,
            style: {
                width: '10rem',  // Adjust the width as needed
            },
        }

    ]

    const customTableStyles = {
        table: {
            style: {
                position: 'relative',
            },
        },
        headRow: {
            style: {
                backgroundColor: '#F1F4F9',
                minHeight: '52px',
                fontWeight: 700,
                borderRadius: '0.4rem',
                borderBottom: 'none',
                // position: 'fixed',
                top: 0,
            },
            denseStyle: {
                minHeight: '32px',
            },
        },
        rows: {
            style: {
                fontSize: '1.4rem',  // Increased text size for rows
                fontWeight: 600,
                color: '#202224',
                borderBottom: '1px solid #EDEFF1',
                minHeight: '70px',
            },
            denseStyle: {
                minHeight: '40px',
            },
        },
        headCells: {
            style: {
                padding: '1rem',
                fontSize: '1.6rem',
                textAlign: 'left',
            },
        },
        cells: {
            style: {
                padding: '1.5rem',
            },
        },
    };


    return (
        <div className="w-full h-full flex flex-col justify-start bg-[#EDEEF1]">
            <div className="w-full h-full flex flex-col bg-[#F2F3F7]">
                <Breadcrumbs
                    breadcrumbs={[
                        { label: "Home", href: "/" },
                        { label: "My Campaigns", href: getUserInfoReducerData?.userType === "AGENCY" ? "/agency/campaigns" : "/brand/campaigns" },
                        { label: "Campaigns Details", href: getUserInfoReducerData?.userType === "AGENCY" ? "/agency/campaigns/details" : "/brand/campaigns/details" },
                    ]}
                />
                <div>
                    <form className="w-full h-full !overflow-y-scroll no-scrollbar p-8 shadow-md space-y-4 mt-5">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <label className="block text-gray-700 font-medium mb-2 text-[1.4rem]">Campaign Name</label>
                                <input
                                    type="text"
                                    readOnly={true}
                                    name="name"
                                    value={formValues.name}
                                    placeholder="Enter campaign name"
                                    className="w-3/4 h-12 border border-gray-300 rounded-md p-2 bg-white focus:outline-none focus:ring focus:ring-green-400 text-[1.4rem]"
                                />
                            </div>
                            <div>
                                <label className="block text-gray-700 font-medium mb-2 text-[1.4rem]">Purpose of the
                                    Campaign</label>
                                <input
                                    type="text"
                                    readOnly={true}
                                    name="purpose"
                                    value={formValues.purpose}
                                    placeholder="Enter purpose"
                                    className="w-3/4 h-12 border border-gray-300 rounded-md p-2 bg-white focus:outline-none focus:ring focus:ring-green-400 text-[1.4rem]"
                                />
                            </div>
                            <div>
                                <label className="block text-gray-700 font-medium mb-2 text-[1.4rem]">Social Media
                                    Platform</label>
                                <input
                                    type="text"
                                    readOnly={true}
                                    name="platform"
                                    value={formValues.platform}
                                    placeholder="e.g., YouTube"
                                    className="w-3/4 h-12 border border-gray-300 rounded-md p-2 bg-white focus:outline-none focus:ring focus:ring-green-400 text-[1.4rem]"
                                />
                            </div>
                            <div>
                                <label className="block text-gray-700 font-medium mb-2 text-[1.4rem]">Campaign Type</label>
                                <input
                                    type="text"
                                    readOnly={true}
                                    name="campaignType"
                                    value={formValues.campaignType}
                                    placeholder="e.g., Video"
                                    className="w-3/4 h-12 border border-gray-300 rounded-md p-2 bg-white focus:outline-none focus:ring focus:ring-green-400 text-[1.4rem]"
                                />
                            </div>
                            <div>
                                <label className="block text-gray-700 font-medium mb-2 text-[1.4rem]">Start Date</label>
                                <input
                                    type="text"
                                    readOnly={true}
                                    name="startDate"
                                    value={formValues.startDate}
                                    className="w-3/4 h-12 border border-gray-300 rounded-md p-2 bg-white focus:outline-none focus:ring focus:ring-green-400 text-[1.4rem]"
                                />
                            </div>
                            <div>
                                <label className="block text-gray-700 font-medium mb-2 text-[1.4rem]">End Date</label>
                                <input
                                    type="text"
                                    readOnly={true}
                                    name="endDate"
                                    value={formValues.endDate}
                                    className="w-3/4 h-12 border border-gray-300 rounded-md p-2 bg-white focus:outline-none focus:ring focus:ring-green-400 text-[1.4rem]"
                                />
                            </div>


                            {formValues?.campaignType == "UGC" ?
                                <div>
                                    <label for="script"
                                        className="block text-gray-700 font-medium mb-2 text-[1.4rem]">Script</label>
                                    <textarea
                                        type="text"
                                        value={formValues?.script}
                                        placeholder="script"
                                        className="w-3/4 h-[8rem] border border-gray-300 text-[1.6rem] text-[#111729] inter-font font-[400] mt-[1rem] rounded-lg p-4 resize-y"
                                        maxLength={1000}
                                        readOnly={true}
                                    />
                                </div>
                                :
                                null
                            }
                            {formValues?.campaignType == "UGC" ?
                                <div>
                                    <label for="dialogue"
                                        className="block text-gray-700 font-medium mb-2 text-[1.4rem]">Dialogue</label>
                                    <textarea
                                        type="text"
                                        value={formValues?.dialogue}
                                        placeholder="dialogue"
                                        className="w-3/4 h-[8rem] border border-gray-300 text-[1.6rem] text-[#111729] inter-font font-[400] mt-[1rem] rounded-lg p-4 resize-y"
                                        maxLength={1000}
                                        readOnly={true}
                                    />
                                </div>
                                :
                                null
                            }
                            {formValues?.campaignType == "UGC" ?
                                <div>
                                    <label for="properties" className="block text-gray-700 font-medium mb-2 text-[1.4rem]">Other
                                        Properites</label>
                                    <textarea
                                        type="text"
                                        value={formValues?.otherProperties}
                                        placeholder="properties"
                                        className="w-3/4 h-[8rem] border border-gray-300 text-[1.6rem] text-[#111729] inter-font font-[400] mt-[1rem] rounded-lg p-4 resize-y"
                                        maxLength={1000}
                                        readOnly={true}
                                    />
                                </div>
                                :
                                null
                            }
                            {formValues?.campaignType == "UGC" ?
                                <div>
                                    <label className="block text-gray-700 font-medium mb-2 text-[1.4rem]">Background
                                        Color</label>
                                    <div className="flex w-3/4">
                                        <input
                                            type="text"
                                            readOnly={true}
                                            name="Color"
                                            value={formValues.backgroundColor}
                                            className=" w-full mr-5 h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem] focus:outline-none focus:ring focus:ring-green-400 text-[1.6rem]"
                                        />
                                        <div
                                            className=" w-full h-[4.8rem] border border-gray-300 rounded-md p-[1.1rem]"
                                            style={{ backgroundColor: formValues.backgroundColor || 'transparent' }}
                                        ></div>
                                    </div>
                                </div>
                                :
                                null
                            }
                            {formValues?.campaignType == "UGC" ?
                                <div className="">
                                    <label className="block text-gray-700 font-medium mb-2 text-[1.4rem]">Location
                                        Required</label>
                                    <input
                                        className="
                                    disabled w-3/4 h-12 border border-gray-300 rounded-md p-2 bg-white focus:outline-none focus:ring focus:ring-green-400 text-[1.4rem]"
                                        value={formValues?.isLocationRequired ? "Yes" : "No"}
                                        readOnly={true}
                                    />
                                </div>
                                :
                                null
                            }

                            {formValues?.referenceVideoUpload && (
                                <div className="flex flex-col space-y-2">
                                    <label className="block text-gray-700 font-medium text-[1.4rem]">Reference Guidance Video</label>
                                    <div className="flex items-center gap-4">
                                        <button
                                            type="button"
                                            disabled={isDownloadingReferenceVideo}
                                            className={`flex items-center gap-2 border border-[#0D9B50] text-white bg-[#0D9B50] px-6 py-3 rounded-[0.8rem] text-[1.4rem] ${isDownloadingReferenceVideo ? 'opacity-60 cursor-not-allowed' : 'hover:scale-95 cursor-pointer'
                                                }`}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setIsDownloadingReferenceVideo(true);
                                                dispatch(
                                                    downloadReferenceVideo(
                                                        { campaignId: formValues.campaignId },
                                                        (status, downloadUrl, message) => {
                                                            setIsDownloadingReferenceVideo(false);
                                                            if (status === 200 && downloadUrl) {
                                                                window.open(downloadUrl, '_blank');
                                                            } else {
                                                                Toast(message || 'Failed to get download URL', 'error');
                                                            }
                                                        }
                                                    )
                                                );
                                            }}
                                        >
                                            <FiDownload /> {isDownloadingReferenceVideo ? 'Loading...' : 'Download Reference Video'}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div>
                            {formValues?.channelNameViewArray?.length > 0 &&
                                <div className="w-full h-full flex flex-col ">
                                    <div
                                        className="w-full flex flex-col justify-between rounded-[2.6rem] bg-[#ffffff] p-[2.4rem]">
                                        <div className="w-full !overflow-y-scroll no-scrollbar">
                                            {Array.isArray(formValues.channelNameViewArray) && formValues.channelNameViewArray.length > 0 ? (
                                                <DataTable
                                                    columns={columns}
                                                    data={formValues.channelNameViewArray}
                                                    customStyles={customTableStyles}
                                                    highlightOnHover
                                                    striped
                                                    responsive
                                                />
                                            ) : (
                                                <div></div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="flex space-x-6 mt-4">
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (getUserInfoReducerData?.userType === "AGENCY") {
                                            navigate("/agency/campaigns")
                                        } else {
                                            navigate("/brand/campaigns")
                                        }
                                    }}
                                    className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400 text-[1.4rem]"
                                >
                                    Back
                                </button>
                            </div>
                        </div>

                    </form>

                </div>
            </div>
        </div>
    )
}

export default BrandCampaignsDetails
